import {
  persistAvatars,
  getNormalizedUrl,
  convertLocaleMobileNumToNumWithDialCode,
} from 'utils';

const sortWebsites = (websites) => {
  websites.sort((a, b) => {
    const x = a.widgetInstalled;
    const y = b.widgetInstalled;
    return x === y ? 0 : x ? -1 : 1;
  });
  return websites;
};

const getStatisticsObject = (channel) => {
  const accepted = {};
  channel.statistics.length > 0 &&
    channel.statistics.reverse().forEach((statistic) => {
      accepted[statistic.day] = statistic.A;
    });
  return accepted;
};

const getChannelOperators = (agents) => {
  let operators = [];

  for (let key in agents) {
    operators.push({
      ...agents[key],
      id: key,
    });
  }

  return operators;
};

export const createWebsitesObject = (apiObject) => {
  const websites = [];
  apiObject.channels.forEach((channel) => {
    if ((channel.url && !channel.url.includes('-deleted')) || !channel.url) {
      persistAvatars(channel.agentsId);
      websites.push({
        id: channel.id,
        url: channel.url ? channel.url : '',
        logoUrl: getNormalizedUrl(
          channel.meta.photo || '/uploads/channel-photos/channel-web.png'
        ),
        widgetInstalled: channel.meta.installed,
        widgetCode: channel.code,
        title: channel.meta.title,
        acceptedConversations: getStatisticsObject(channel),
        isActive: channel.status === '1' ? true : false,
        operatorIds: channel.agentsId,
        operators: getChannelOperators(channel.agents),
        permissionWhatsapp: channel.permissionWhatsapp ? true : false,
        token: channel.token,
      });
    }
  });
  return sortWebsites(websites);
};

const getRemainingConvsText = (accountType, remainingConvs) => {
  if (accountType === 8) {
    return {
      en: 'Unlimited',
      fa: 'نامحدود',
    };
  }
  return {
    en: `${remainingConvs}`,
    fa: `${remainingConvs} عدد`,
  };
};

const getRemainingDaysText = (remainingDays) => ({
  en: `${remainingDays} days`,
  fa: `${remainingDays} روز`,
});

export const createProfileObject = (apiObject) => {
  const account = apiObject.account;
  const user = apiObject.user;
  let isCreatorAdmin =
    localStorage.getItem('isCreatorAdmin') === 'true' ? true : false;
  return {
    accountType: account.type,
    userId: user.id,
    fullName: user.name,
    email: user.email,
    accessLevel: user.type === '2' ? 'admin' : 'user',
    isCreatorAdmin: isCreatorAdmin,
    mobile: convertLocaleMobileNumToNumWithDialCode(user.phone),
    image:
      user.avatar === null || !user.avatar ? '' : getNormalizedUrl(user.avatar),

    remainingConversations: getRemainingConvsText(
      account.type,
      account.conversationCharge
    ),
    convsArchiveRange: apiObject.raypackage.conversationArchive,

    // account's purchased duration
    accountDuration: account.myMonth,
    remainingConvsNum: account.conversationCharge,
    remainingDaysNum: account.time,
    remainingDays: getRemainingDaysText(account.time),
    widgetBroadcastMessageCount: apiObject.raypackage.broadcastMessageCount,
    exportChatsEnabled: apiObject.raypackage.exportChats,
    exportUsersConvsEnabled: apiObject.raypackage.archive.exportData,

    // max allowed sites that a user can have according to their package
    maxSiteCount: apiObject.raypackage.siteCount,
    userCredit: apiObject?.userCredit || 0,
  };
};

const getTeamAgents = (agentsId, agents) => {
  let adaptedAgents = [];

  agentsId.forEach((id) => {
    adaptedAgents.push({
      name: agents[id]?.name,
      id: id,
    });
  });

  return adaptedAgents;
};

const getChannelTeam = (team, agents) => {
  let adaptedTeam = [];

  team.forEach((item) => {
    adaptedTeam.push({
      url: item.url,
      index: item.index,
      agents: getTeamAgents(item.agentsId, agents),
    });
  });

  return adaptedTeam;
};

export const createChannelsTeamObject = (channels) => {
  let channelsTeam = {};
  channels.forEach((channel) => {
    if (channel.team) {
      channelsTeam[channel.id] = getChannelTeam(channel.team, channel.agents);
    }
  });

  return channelsTeam;
};
